import { DetermineBrightness } from "./DetermineBrightness";
import { SVG_DrawText } from "./SVG_DrawText";
import { gBrightnessThreshold } from "../constants";

export function SVG_DrawAnnoLabel(
  annoLabel,
  raw_bounds,
  triSize,
  triColor,
  triPosition,
  drawElement
) {
  var tSize = triSize;

  var t3 = 0.3333 * tSize;
  var t2 = 0.3333 * tSize;

  var sx = triPosition == 0 ? raw_bounds.fRight - t2 : raw_bounds.fLeft + t2;
  var sy = raw_bounds.fTop + t3;

  var fillStyle = "#000000";
  if (triColor != null)
    fillStyle = DetermineBrightness(triColor) < gBrightnessThreshold ? "#FFFFFF" : "#000000";

  SVG_DrawText(
    annoLabel,
    sx,
    sy,
    fillStyle,
    "Tahoma",
    11,
    true,
    false,
    false,
    "center",
    "middle",
    null,
    drawElement
  );
}
